<template>
  <el-dialog title="移除区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <Title :isLine="false">移除区域</Title>
    <el-form ref="dataForm" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="" prop="childDetail">
        <div v-for="(item,index) in form.childDetail" :key="index" class="full-box">
          <el-cascader v-model="item.districtCode" :props="cascaderProps" collapse-tags :options="options.areaOptions" placeholder="请选择需要移除的区域" clearable>
            <template slot-scope="{ node, data }">
              <div>
                <span>{{ data.areaName }}</span>
                <span v-if="data.isSendOtherChildAuth === 1" style="color: #409EFF; margin-left: 5px; font-size: 12px;">
                  (已向其他下级授权)
                </span>
              </div>
            </template>
          </el-cascader>
          <el-select v-model="item.customerId" placeholder="请选择业务员" clearable size="small" filterable :filter-method="identityFilter" @blur="getBusinessList()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.name} (${it.pho})${it.levelName}`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddCustomer"></i>
            <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import clientListApi from '@/api/client/clientList'
import clientAreaApi from '@/api/client/clientArea'

function initFormBean() {
  const formBean = {
    childDetail: [{
      customerId: '',
      districtCode: ''
    }]
  }
  return formBean
}
export default {
  // props: ['identityOptions'],
  data() {
    return {
      formVisible: false,
      form: initFormBean(),
      isLoading: false,
      options: {
        areaOptions: [],
        identityOptions: []
      },
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true,
        emitPath: true,
      },

      info: {}
    }
  },
  methods: {
    identityFilter(e) {
      this.getBusinessList(e)
    },
    // 获取业务员
    getBusinessList(val) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100,
        name: val
      }
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.options.identityOptions = data.list.filter(i => i.id != this.info.id)
        // console.log('业务员列表: ',data);
      })
    },
    // 获取地区
    changeIdentity() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      clientAreaApi.fetchTreeList({
        customerId: this.info.id,
        parentCustomerId: this.info.parentId,
        addOrDelete: 2,
        v: 3
      }).then(({
        data
      }) => {
        this.loading.close()
        this.options.areaOptions = this.formatCascaderData(data)
        this.formVisible = true
      }).catch(() => {
        this.loading.close()
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    cascaderData(data) {
      return data.reduce((data, item) => (data.push(...item.districtCode.map(id => ({
        ...item,
        provinceCode: id[0],
        cityCode: id[1],
        districtCode: id[2],
        areaType: 3
      }))), data), [])
    },
    handleDeleteCustomer(index) {
      if (this.form.childDetail.length <= 1) return
      this.form.childDetail.splice(index, 1)
    },
    handleAddCustomer() {
      this.form.childDetail.push({
        customerId: '',
        districtCode: ''
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    handleUpdate(row) {
      this.info = row
      // this.id = row.id
      // this.clevel=clevel
      console.log('clevel11111: ', row);
      this.resetForm()

      this.$nextTick(() => {
        this.getBusinessList()
        this.changeIdentity()
      })
    },
    doCreate() {
      // if(!arr.length) return this.$message.error('内容不能为空')
      // console.log('this.form.childDetail: ',this.form.childDetail);

      if (!this.form.childDetail[0].districtCode || !this.form.childDetail[0].customerId) return this.$message.error('内容不能为空')
      let arr = this.cascaderData(this.form.childDetail)
      this.isLoading = true
      clientAreaApi.makeTransfer({
        id: this.info.id,
        detail: arr,
        // dataCompareLogType2:25
      })
        .then(() => {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
          this.isLoading = false
        }).catch(res => {
          this.isLoading = false
        })

    }
  }
}
</script>
<style lang="scss" scoped>
// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 50%;
  margin-left: 5px;
}

::v-deep .el-cascader {
  width: 100%;
  // height: 32px;
  // line-height: 32px;

  // input {
  //   height: 32px;
  //   line-height: 32px;
  // }
}

::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
